// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1l-o";
export var animationRelative = "_1l-n";
export var backdropBlur = "_1l-0";
export var detailLabelCell = "_1l-10";
export var detailTable = "_1l-z";
export var detailValueCell = "_1l-11";
export var docIconBox = "_1l-19";
export var docTypeRow = "_1l-14";
export var docTypeRowInner = "_1l-15";
export var dropdownMatchDatePicker = "_1l-1";
export var fileUploadSpin = "_1l-h";
export var gorgiasOpenButton = "_1l-13 _1l-b";
export var gorgiasTicketCard = "_1l-12";
export var heroModalFooterButton = "_1l-16";
export var hiddenContainer = "_1l-m";
export var maxWidthContainer = "_1l-17";
export var modalContentBody = "_1l-8";
export var modalHeaderImage = "_1l-3";
export var modalImageLabel = "_1l-5";
export var modalImageOverlay = "_1l-4";
export var modalImageSubtitle = "_1l-7";
export var modalImageTitle = "_1l-6";
export var modalImageWrapper = "_1l-2";
export var modalStickyFooter = "_1l-9";
export var removeButton = "_1l-c";
export var sidebarColumn = "_1l-18";
export var spinner = "_1l-g";
export var timelineLine = "_1l-w";
export var timelineLineBlack = "_1l-y _1l-w";
export var timelineLineGray = "_1l-x _1l-w";
export var timelineLineHeight = "_1l-v";
export var tlDotActivate = "_1l-s";
export var tlDotActivateAnim = "_1l-r";
export var tlDotHide = "_1l-q";
export var tlDotHideAnim = "_1l-p";
export var tlLineActivate = "_1l-u";
export var tlLineActivateAnim = "_1l-t";
export var uploadHint = "_1l-l";
export var uploadIconBox = "_1l-i";
export var uploadLabel = "_1l-k";
export var uploadText = "_1l-j";
export var uploadZone = "_1l-d";
export var uploadZoneCursorDefault = "_1l-f";
export var uploadZoneCursorPointer = "_1l-e";
export var uploadedFileRow = "_1l-a";
export var viewButton = "_1l-b";